/**
 * @generated SignedSource<<68d69686601cf9c56fe70b23dded2132>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type loansPage_FlagMutation$variables = {
  txnId: string;
};
export type loansPage_FlagMutation$data = {
  readonly loanFlagTxn: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly loan: {
      readonly id: string;
    } | null | undefined;
  } | null | undefined;
};
export type loansPage_FlagMutation = {
  response: loansPage_FlagMutation$data;
  variables: loansPage_FlagMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "txnId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "txnId",
    "variableName": "txnId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Loan",
  "kind": "LinkedField",
  "name": "loan",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "loansPage_FlagMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoanFlagTxnMutationPayload",
        "kind": "LinkedField",
        "name": "loanFlagTxn",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "loansPage_FlagMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "LoanFlagTxnMutationPayload",
        "kind": "LinkedField",
        "name": "loanFlagTxn",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "eadcce3b5a61cd5cd1364e937a97320c",
    "id": null,
    "metadata": {},
    "name": "loansPage_FlagMutation",
    "operationKind": "mutation",
    "text": "mutation loansPage_FlagMutation(\n  $txnId: ID!\n) {\n  loanFlagTxn(txnId: $txnId) {\n    loan {\n      id\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "80b97aca5ad71846daa2ae467be538f7";

export default node;
